export const dataSetUf = [
  {
    nome: "Todas",
    marcado: false,
    fixo: false,
  },
  {
    nome: "AC",
    value:"AC",
    marcado: false,
    fixo: false,
  },
  {
    nome: "AL",
    value: "AL",
    marcado: false,
    fixo: false,
  },
  {
    nome: "AM",
    value: "AM",
    marcado: false,
    fixo: false,
  },
  {
    nome: "AP",
    value: "AP",
    marcado: false,
    fixo: false,
  },
  {
    nome: "BA",
    value: "BA",
    marcado: false,
    fixo: false,
  },
  {
    nome: "CE",
    value: "CE",
    marcado: false,
    fixo: false,
  },
  {
    nome: "DF",
    value: "DF",
    marcado: false,
    fixo: false,
  },
  {
    nome: "ES",
    value: "ES",
    marcado: false,
    fixo: false,
  },
  {
    nome: "GO",
    value: "GO",
    marcado: false,
    fixo: false,
  },
  {
    nome: "MA",
    value: "MA",
    marcado: false,
    fixo: false,
  },
  {
    nome: "MG",
    value: "MG",
    marcado: false,
    fixo: false,
  },
  {
    nome: "MS",
    value: "MS",
    marcado: false,
    fixo: false,
  },
  {
    nome: "MT",
    value: "MT",
    marcado: false,
    fixo: false,
  },
  {
    nome: "PA",
    value: "PA",
    marcado: false,
    fixo: false,
  },
  {
    nome: "PB",
    value: "PB",
    marcado: false,
    fixo: false,
  },
  {
    nome: "PE",
    value: "PE",
    marcado: false,
    fixo: false,
  },
  {
    nome: "PI",
    value: "PI",
    marcado: false,
    fixo: false,
  },
  {
    nome: "PR",
    value: "PR",
    marcado: false,
    fixo: false,
  },
  {
    nome: "RJ",
    value: "RJ",
    marcado: false,
    fixo: false,
  },
  {
    nome: "RN",
    value: "RN",
    marcado: false,
    fixo: false,
  },
  {
    nome: "RO",
    value: "RO",
    marcado: false,
    fixo: false,
  },
  {
    nome: "RR",
    value: "RR",
    marcado: false,
    fixo: false,
  },
  {
    nome: "RS",
    value: "RS",
    marcado: false,
    fixo: false,
  },
  {
    nome: "SC",
    value: "SC",
    marcado: false,
    fixo: false,
  },
  {
    nome: "SE",
    value: "SE",
    marcado: false,
    fixo: false,
  },
  {
    nome: "SP",
    value: "SP",
    marcado: false,
    fixo: false,
  },
  {
    nome: "TO",
    value: "TO",
    marcado: false,
    fixo: false,
  },
];
